import React, { useState } from 'react';
import classNames from 'classnames';

import { CLUSTER_HEADER_CATEGORY } from '../../../utils/constant';
import BreadCrumbs from '../../BreadCrumbs';
import CareerClusterHeaderTitle from '../careerClusterHeader/CareerClusterHeaderTitle';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

const CareerComboClusterHeader = ({ subPageName, ...data }) => {
  const { title, layTitleDisplay, city, stateAbbr, state } = data.criteria;

  const IS_STATE_COMBO = !!city === false && !!state === true;

  const { topBreadCrumbs, breadCrumbs, locationDisplay, cityJobs } = data;
  const pageHeader = IS_STATE_COMBO
    ? `${layTitleDisplay || title} Jobs in ${state}`
    : `${layTitleDisplay || title} Jobs in ${`${city}, ${stateAbbr}`}`;

  const showBreadCrumbs = false;

  const [pageTitle, setPageTitle] = useState('');

  return (
    <>
      <div
        className={classNames('job-title-search', 'container', {
          'd-flex flex-column-reverse flex-lg-row align-items-start': showBreadCrumbs === false,
        })}
      >
        {showBreadCrumbs === true && (
          <div className="job-title-search-row">
            {breadCrumbs && (
              <BreadCrumbs
                breadCrumbs={topBreadCrumbs || breadCrumbs.slice(0, 3)}
                containerClassName="cluster-header-breadcrumbs-container"
              />
            )}

            <SearchBar
              subPageName={subPageName}
              clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
              jobLocation={locationDisplay}
              className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
                'z-mt-lg-44': pageTitle.length > 40,
                'z-mt-lg-40': pageTitle.length <= 40,
              })}
            />
          </div>
        )}
        <CareerClusterHeaderTitle
          title={pageHeader}
          subPageTextSmall={data.subPageTextSmall}
          showJobsCount
          jobCount={data?.jobsCountForHeader || cityJobs?.totalJobs}
          getPageTitle={(_pageTitle) => setPageTitle(_pageTitle)}
        />

        {!showBreadCrumbs && (
          <SearchBar
            subPageName={subPageName}
            clusterCategory={CLUSTER_HEADER_CATEGORY.CAREER}
            jobLocation={locationDisplay}
            className={classNames('z-mt-12 z-mb-20 z-mb-lg-0 z-ml-lg-20', {
              'z-mt-lg-44': pageTitle.length > 40,
              'z-mt-lg-40': pageTitle.length <= 40,
            })}
          />
        )}
      </div>
      <div className="sub-header-container">
        <SubHeader {...data} />
      </div>
    </>
  );
};

export default CareerComboClusterHeader;
